import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import Layout from '@/components/Layout';
import Login from '@/pages/Login';
import DashboardOverview from '@/pages/DashboardOverview';
import OutOfStock from '@/pages/OutOfStock.tsx';
import ProductDetail from '@/pages/ProductDetail';
import Settings from '@/pages/Settings';
import Alerts from '@/pages/Alerts';
import ExcludedProducts from '@/pages/ExcludedProducts';
import SlowMovers from '@/pages/SlowMovers';
import MasterDataCoverage from '@/pages/MasterDataCoverage';
import PurchaseOrders from '@/pages/PurchaseOrders';
import PurchaseOrderDetail from '@/pages/PurchaseOrderDetail';
import Impressum from '@/pages/Impressum';
import Datenschutz from '@/pages/Datenschutz';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-600" />
      </div>
    );
  }
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/impressum" element={<Impressum />} />
      <Route path="/datenschutz" element={<Datenschutz />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardOverview />} />
        <Route path="lagerrisiken" element={<OutOfStock />} />
        <Route path="bestelllisten" element={<PurchaseOrders />} />
        <Route path="bestelllisten/:id" element={<PurchaseOrderDetail />} />
        <Route path="products/:sku" element={<ProductDetail />} />
        <Route path="slow-movers" element={<SlowMovers />} />
        <Route path="alerts" element={<Alerts />} />
        <Route path="stammdaten" element={<MasterDataCoverage />} />
        <Route path="excluded-products" element={<ExcludedProducts />} />
        <Route path="settings" element={<Settings />} />
        {/*<Route path="data-quality" element={<DataQuality />} />*/}
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
